const translations = {
  PRIMARY_BALANCE: 'Primary Balance',
  SECONDARY_BALANCE: 'Secondary Balance',
  PAYMENT: 'Payment',
  HISTORY: 'Balance History',
  BALANCE: 'Balance'
};

export default translations;
